import { useSelector } from 'react-redux';
import { AppState } from '@src/reducers';
import { AuthModel } from '@src/auth/auth-model';

export function useAuth(): AuthModel {
  return useSelector<AppState, AuthModel>((state) => state.auth);
}
